<template>
    <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
</template>

<script>
import ProcessosServicos from './ProcessosServicos'

export default {
    data() {
        return {
            item: {},
            erros: []
        }
    },

    methods: {
        obterContratoItemGestor() {
            this.$store.dispatch('addRequest')
            let contratoId = this.$route.query.c
            let itemContratoId = this.$route.query.i
            ProcessosServicos.obterContratoItemGestor(contratoId,itemContratoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.item = response.data
                        this.confirmarFinalizarAvisosSaldoItemContrato()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarFinalizarAvisosSaldoItemContrato() {
            this.$swal({
                title: 'Avisos de Saldo do Item do Contrato',
                html: `Confirma a finalização dos avisos de saldo do item <b>${this.item.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.finalizarAvisosSaldoItemContrato(result.value)
                } else {
                    this.$router.push('/')
                }
            })
        },

        finalizarAvisosSaldoItemContrato() {
            this.$store.dispatch('addRequest')
            let finalizarDto = {
                idContrato: this.$route.query.c,
                percentual: this.$route.query.p,
                idItemContrato: this.$route.query.i
            }
            ProcessosServicos.finalizarAvisosSaldoItemContrato(finalizarDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.finalizacaoRealizadaComSucesso()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        finalizacaoRealizadaComSucesso() {
            this.$swal({
                title: 'Avisos de Saldo do Item',
                html: `Finalizados com Sucesso`,
                icon: 'success'
            }).then(result => {
                if (result.value) {
                    this.$router.push('/')
                }
            })
        }
    },

    created() {
        this.obterContratoItemGestor()
    }
}
</script>
